export default __webpack_public_path__ + "static/media/chapter.2f9ffcb4.jpg";